import React, { useEffect, useState } from "react";
import { fetchCmsContent } from "../services/fetchCmsContent";
import MainPageComponents from "../components/CommonComponents/MainPageComponents";

interface PrivacyItem {
  title: string;
  slug: string;
  content: string;
}

const PrivacyDataProtectionPage: React.FC = () => {
  const [privacy, setPrivacy] = useState<PrivacyItem | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchCmsContent("Privacy Data Protection", "/api/cms/privacy-data-protection", setPrivacy, setLoading);
  }, []);

  return (
    <MainPageComponents
      title={privacy?.title || "Privacy Data Protection"}
      content={privacy?.content || ""}
      loading={loading}
      updated_at=""
    />);
};

export default PrivacyDataProtectionPage;
